var _style, _desc, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTether1 = function SvgTether1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 720",
    width: 2500,
    height: 2500,
    ref: ref,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#26a17b}.st1{fill:#fff}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tether") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    className: "st0",
    d: "M360 0c198.8 0 360 161.2 360 360S558.8 720 360 720 0 558.9 0 360 161.2 0 360 0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(336.29 -181.139)",
    id: "Vector_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    className: "st1",
    d: "M74.4 501v-53.6h122.5v-81.6h-333.5v81.6h122.5V501c-99.5 4.6-174.4 24.3-174.4 47.9 0 23.6 74.9 43.3 174.4 47.9v171.5h88.6V596.8c99.4-4.6 174.1-24.3 174.1-47.9-.1-23.6-74.8-43.3-174.2-47.9zm.1 81.3c-2.5.1-15.3.9-43.9.9-22.9 0-38.9-.6-44.6-.9v.1c-87.9-3.9-153.6-19.2-153.6-37.5S-102 511.3-14 507.4V567c5.8.4 22.2 1.4 45 1.4 27.3 0 41-1.1 43.6-1.4v-59.8c87.8 3.9 153.3 19.2 153.3 37.5-.2 18.3-65.7 33.6-153.4 37.6"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTether1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tether-1.34323ecaaf4a262de93f8f2f0529ef56.svg";